<template>
  <iframe
    v-if="form != null"
    :src="form.specs.src"
    v-bind="layout"
    :width="form.specs.width || '100%'"
    :height="form.specs.height || '1700'"
    :style="form.specs.style"
    frameBorder="0"
    allowtransparency
  >
    <p>Your browser does not support iframes.</p>
  </iframe>
</template>

<script>
import ApiService from '../APIService.js'

export default {
  props: {
    formId: {
      type: String,
      required: true
    },
    layout: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      form: null
    }
  },
  created() {
    ApiService.getFormById(this.formId)
      .then((res) => {
        this.form = res.data
      })
      .catch(() => {
        console.log('Could not fetch iframe form: ' + this.formId)
      })
  }
}
</script>
